import { createContext } from 'react'

const ToastConnectionContext = createContext({ signalRConnection: undefined, setSignalRConnection: connection => { } });
export default ToastConnectionContext